<template>
   <div class="apply">
       <van-nav-bar
       title="提料申请"
       left-arrow
       safe-area-inset-top
       :border="false"
        @click-left="leftClick"
     />
    <div class="TipsBg">
        <div class="tipsTxt">
                <div class="txtBg"></div>
                <div class="txt">
                    <h1>提料申请提交成功！</h1>
                    <p>申请已进入审核(审核时间为10:00-17:00)，</p>
                    <p>提交付款凭证截图可加快审核喔！ <strong class="comfig">去提交</strong> <span  class="icon"></span></p>
                </div>
        </div>
    </div>
    <div class="orderInfo">
         <div class="top"></div>
        <div class="orderbg">
                        <!-- 提料单号 -->
                <div class="oddNumbers flex">
                    <div class="odd flexleft">提料单号:</div>
                    <div class="number">{{orderInfo.openNo}}</div>
                </div>
                <!-- 提交时间 -->
                 <div class="oddTime flex">
                    <div class="odd flexleft">提交时间:</div>
                    <div class="Time flexRight">{{orderInfo.createdTime}}</div>
                </div>
                 <div class="buyOrder flex">
                    <div class="buy flexleft">买料单数:</div>
                    <div class="number flexRight">{{orderInfo.count}}</div>
                </div>
                 <div class="type flex">
                    <div class="orderType flexleft">种类:</div>
                    <div class="category flexRight">{{orderInfo.goods}}</div>
                </div>
                <div class="totalWeight flex">
                    <div class="weight flexleft">总重:</div>
                    <div class="number flexRight">{{orderInfo.weight}}克</div>
                </div>              
                 <div class="totalMoney flex">
                    <div class="money flexleft">总金额:</div>
                    <div class="number flexRight">{{orderInfo.money}}元</div>
                </div>

                <div class="zhanghu flexleft">中鑫金收款账户</div>
                <div class="BankOfDeposit flex">
                    <div class="bank flexleft">开户行:</div>
                    <div class="bankName flexRight">{{orderInfo.bankInfo.bank}}</div>
                </div>
                <div class="collectionRen flex">
                    <div class="collection flexleft">收款人:</div>
                    <div class="collectionRen flexRight">{{orderInfo.bankInfo.name}}</div>
                </div>
                 <div class="accountNumber  flex">
                    <div class="account  flexleft">账号:</div>
                    <div class="number flexRight">{{orderInfo.bankInfo.num}}</div>
                </div>
        </div>
        <div class="know" @click="iKnow">
            我知道了
        </div>
    </div>
            <div class="goSeeSee">
            对应的结算单已经生成，可提交付款凭证截图，<i @click="goSeeSee"></i>
        </div>
   </div>
</template>

<script>
import headbox from "@/components/head.vue";
import { mapState } from 'vuex'
export default {
    components:{
        headbox
    },
      computed: {
    ...mapState(['orderInfo'])
    },
    data() {
        return {
        }
    },
    methods:{
        goSeeSee(){
            this.$router.push({
                name:'purchaseSettlement',
                query:{openId:this.orderInfo.openId}
            })
        },
        iKnow(){
            this.leftClick()
        },
        leftClick(){
            this.$router.push({
                name:'purchaseOrder'
            })
        }
    },
    created(){
        console.log(this.orderInfo);

    }
}
</script>

<style lang="scss" scoped="true">
    .TipsBg{
        width: 100%;
        height: 500px;
        padding: 30px;
        background: url("~@/assets/images/rectangular4.png") no-repeat;
        background-size:100% 100%;
        .tipsTxt{
            width: 100%;
            height: 158px;
            margin-top: 100px;
            display: flex;
            .txtBg{
                width: 190px;
                height: 158px;
                background: url("~@/assets/images/tick.png") no-repeat;
                background-size: 100% 100%;
            }
            .txt{
                width: 100%;
                padding: 8px 10px 0 30px;
                color: #fff;
                position: relative;
                h1{
                    font-size: 36px;
                    font-weight: 400;
                    margin-bottom: 20px;
                }
                p{
                    font-size: 16px;
                }
                .comfig{
                    font-size: 18px;
                }
                .icon{
                    position: relative;
                    top: 2px;
                    width: 20px;
                    height: 16px;
                    background: url("~@/assets/images/＞.png");
                    background-size: 100% 100%;
                }
            }
        }
    }
    .orderInfo{
        position: relative;
        top: -150px;
        width: 560px;
        height: 620px;
        margin: 0 auto;
        .top{
            width: 100%;
            height: 10px;
            background: url("~@/assets/images/rectangular3.png");
            background-size: 100% 100%;

        }
        .orderbg{
            width: 100%;
            height: 600px;
            background: url("~@/assets/images/rectangular2.png");
            background-size: 100% 100%;
            position: relative;
            top: -10px;
            padding: 30px 0px 30px 50px;
            .zhanghu{
                margin-top: 50px;
                margin-bottom: 20px;
                width: 200px !important;
                text-align: left !important;
            }
        }
        .know{
            width: 340px;
            height: 80px;
            background-color: #f9b324;
            margin: 20px auto;
            text-align: center;
            line-height: 80px;
            color: #fff;
            font-size: 28px;
            border-radius: 50px;
        }
    }
    .goSeeSee{
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #CCCCCC;
        text-align: center;
        position: relative;
        font-size: 20px;
       i{
           position: absolute;
           top: 2px;
           width: 100px;
           height: 30px;
           background: url("~@/assets/images/look.png") no-repeat;
           background-size: 100% 100%;
       }
    }
    .flex{
        display: flex;
        margin-bottom: 18px;
    }
    .flexleft{
        color: #CCCCCC;
        text-align: right;
        width: 120px;
        margin-right: 10px;
        font-size: 18px;
        font-family: MicrosoftYaHei;
    }
    .flexRight{
        font-size: 18px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #1A1A1A;
    }
    ::v-deep{
     .van-nav-bar{
        height: 100px;
        background-color: #f9b324;
        .van-nav-bar__content{
        line-height: 100px;
        height: 100px;
        .van-nav-bar__title{
            font-size: 40px;
            color: #fff;
        }
        .van-icon{
            font-size: 40px;
            color: #fff;
        }
        }
     }
}
</style>